<div class="p-5">
    <div class="text-center">
        <h1 class="h4 text-gray-900 mb-4">Forgot Your Password?</h1>
        <p class="mb-4">We get it, stuff happens. Just enter your email address below
            and we'll send you a link to reset your password!</p>
    </div>
    <form class="user">
        <div class="form-group">
            <input name="email" type="email" class="form-control form-control-user" aria-describedby="emailHelp"
                placeholder="Email" [(ngModel)]="email" (focus)="errorMessage = ''">
        </div>
        <button (click)="forgotPassword()" class="btn btn-primary btn-user btn-block">
            Reset Password
        </button>
    </form>
    <hr>

    <div class="text-center">
        <button mat-button routerLink="/register">Create an Account!</button>
    </div>
    <div class="text-center">
        <button mat-button routerLink="/login">Already have an account? Login!</button>
    </div>
</div>